<template>
  <div class="box5-page">
    <div class="inseec-title">院校介绍</div>
    <div class="content-box">
      <p>
        INSEEC高等商学院是OMNES Education的集团成员，OMNES
        Education.在法国本土巴黎、里昂、波尔多和尚贝里以及摩纳哥、英国伦敦、瑞士日内瓦、美国旧金山以及科特迪瓦阿比让等全球9个城市开设有13所学校，17个校区，在校生35,000人，毕业生180000人，拥有131,000,000欧元（一亿三千一百万欧元）的滚动科研建设资金，与中国清华等多所大学有合作办学项目。<br />
        学院颁发国家本科和硕士、博士文凭，是法国大学校会议（CGE）的成员之一，集团还拥有EFMD、AMBA、AACSB、CVTRUST、UGEI等国际认证。
      </p>
      <img src="../../../assets/coursePage/inseec/box5/1.png" alt="" />
      <img src="../../../assets/coursePage/inseec/box5/2.png" alt="" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .box5-page {
    background: #012d72;
    padding: 80px 40px;
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
    .content-box {
      padding-top: 48px;
      > img {
        width: 100%;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      > p {
        font-weight: 400;
        font-size: 26px;
        color: #ffffff;
        line-height: 40px;
        margin-bottom: 40px;
      }
    }
  }
</style>
